import { useEffect, useState } from "react";
import Telemetry from "./Telemetry";
import "./App.css";
import { getGameClientId, getGameClientSecret, getGameRedirectUrl, getGameAuthority, getGameTokenEndpoint} from './constants';
import axios from "axios";
import randomstring from "randomstring";

const rootStyle = {
  opacity: "0.75",
  backgroundColor: "black",
};

function App() {

  const [returnValue, setReturnValue] = useState<JSX.Element>();

  useEffect(() => {

    setReturnValue(<div className="App" style={rootStyle}>
        <Telemetry />
      </div>)
    return;

    // GAME TEMPORARILY DISABLED
    
    // if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    //   setReturnValue(<div className="App" style={rootStyle}>
    //     <Telemetry />
    //   </div>)
    // return;
    // }

    // const urlParams = new URLSearchParams(window.location.search);
    // const gameClientID = getGameClientId();
    // const redirectURL = getGameRedirectUrl();
    // const client_secret = getGameClientSecret();
    // const gameAuthority = getGameAuthority();

    // const hasCode = urlParams.has("code");

    // if (!hasCode) {
    //   const state = randomstring.generate();
    //   //Random code verifier to then generate codeChallenge from it.
    //   const code_verifier = randomstring.generate(128);
    //   saveStateAndVerifier(state, code_verifier);
    //   const gamev3Url = gameAuthority;
    //   generateCodeChallenge(code_verifier).then((challenge) => {
    //     console.log(challenge);
    //     window.location.href = `${gamev3Url}?client_id=${gameClientID}&response_type=code
    //       &scope=openid&state=${state}&redirect_uri=${redirectURL}&code_challenge=${challenge}&code_challenge_method=S256`;
    //   });
    // } else if (urlParams.has("error")) {
    //   setReturnValue(
    //   <div>
    //     <h1>not authorized</h1>
    //   </div>
    //   )
    // } else {
    //   const currentLocation = new URL(window.location.href);
    //   const stateFromLocation = currentLocation.searchParams.get("state");

    //   if (window.sessionStorage.getItem("state") !== stateFromLocation) {
    //     throw Error("Probable session error!");
    //   }
    //   getToken(gameClientID, redirectURL, client_secret);
    // }
  }, [])

  if (returnValue === undefined) {
    setReturnValue(
      <div className="App" style={rootStyle}>
          <Telemetry />
      </div>
    )
  }

  return(
    <div>
      {returnValue}
    </div>
  );
}

function saveStateAndVerifier(state: string, code_verifier: string) {
  /*
  Don't overwrite our saved state if location has the state parameter.
  This means we got authorization from the AS, and we need to compare them later.
  */
  if (window.location.search.includes("state")) return;
  const storage = window.sessionStorage;
  storage.clear();
  storage.setItem("state", state);
  storage.setItem("code_verifier", code_verifier);
}

async function generateCodeChallenge(codeVerifier: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  const toBase64 = Buffer.from(digest).toString("base64");
  
  return toBase64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

function getToken(client_id: string, redirect_uri: string, client_secret: string) {

  const gameTokenEndpoint = getGameTokenEndpoint();
  const tokenEndpoint = new URL(gameTokenEndpoint);

  const currentLocation = new URL(window.location.href);
  const authorizationCode = currentLocation.searchParams.get("code");
  const stateFromLocation = currentLocation.searchParams.get("state");
  const initialCodeVerifier = window.sessionStorage.getItem("code_verifier");

  // Check state
  if (window.sessionStorage.getItem("state") !== stateFromLocation) {
    throw Error("Probable session error");
  }

  const config = {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  };

  const requestBody = {
    client_id,
    grant_type: "authorization_code",
    state: stateFromLocation,
    code: authorizationCode,
    code_verifier: initialCodeVerifier,
    redirect_uri,
    client_secret
  };

  console.log(requestBody);
  for (const param in requestBody) {
    tokenEndpoint.searchParams.append(
      param,
      requestBody[param as keyof typeof requestBody]!
    );
  }
  const url = gameTokenEndpoint;
  axios.post(url, requestBody, config).then((body: any) => {
    console.log(body);
  });
}

export default App;
